module.exports = "/_next/static/images/avatar-default-5d22783eb9471ecf45027b8e12f414b0.jpg";